import { CoreModel } from '../core/core.model';
export class FormQuestionModel extends CoreModel {
/**
 * Question ID
 */
questionID?: string;
/**
 * Тame of the component by which the question should be displayed. Can be: input, checkbox, switch, radio, select.
 */
componentType?: string;
/**
 * Type of cf-input
 */
type?: string;
/**
 * Whether question is required
 */
required?: boolean;
/**
 * Question key
 */
key?: string;
/**
 * Question value
 */
value?: string;
/**
 * Question label
 */
label?: string;
/**
 * Property used when componentType is: checkbox, radio or switch.
 */
minSelected?: number;
/**
 * Property used when componentType is: checkbox, radio or switch.
 */
maxSelected?: number;
/**
 * Array for options when componentType is select.
 */
items?: any[];
/**
 * Validation settings
 */
validation?: any;
/**
 * Question details
 */
details?: any;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormQuestionModel_tsickle_Closure_declarations() {
/**
 * Question ID
 * @type {?}
 */
FormQuestionModel.prototype.questionID;
/**
 * Тame of the component by which the question should be displayed. Can be: input, checkbox, switch, radio, select.
 * @type {?}
 */
FormQuestionModel.prototype.componentType;
/**
 * Type of cf-input
 * @type {?}
 */
FormQuestionModel.prototype.type;
/**
 * Whether question is required
 * @type {?}
 */
FormQuestionModel.prototype.required;
/**
 * Question key
 * @type {?}
 */
FormQuestionModel.prototype.key;
/**
 * Question value
 * @type {?}
 */
FormQuestionModel.prototype.value;
/**
 * Question label
 * @type {?}
 */
FormQuestionModel.prototype.label;
/**
 * Property used when componentType is: checkbox, radio or switch.
 * @type {?}
 */
FormQuestionModel.prototype.minSelected;
/**
 * Property used when componentType is: checkbox, radio or switch.
 * @type {?}
 */
FormQuestionModel.prototype.maxSelected;
/**
 * Array for options when componentType is select.
 * @type {?}
 */
FormQuestionModel.prototype.items;
/**
 * Validation settings
 * @type {?}
 */
FormQuestionModel.prototype.validation;
/**
 * Question details
 * @type {?}
 */
FormQuestionModel.prototype.details;
}

